import { render, staticRenderFns } from "./InitialMedication.vue?vue&type=template&id=39c18d64&scoped=true&"
import script from "./InitialMedication.vue?vue&type=script&lang=js&"
export * from "./InitialMedication.vue?vue&type=script&lang=js&"
import style0 from "./InitialMedication.vue?vue&type=style&index=0&id=39c18d64&scoped=true&lang=css&"
import style1 from "./InitialMedication.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c18d64",
  null
  
)

export default component.exports